import { Component, Input, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-notification-dialog',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss'],
    standalone: false
})
export class NotificationDialogComponent implements OnInit {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() dataRows: any[] = [];
  @Input() columns: any[] = [];
  @Input() showGrid: boolean = true;
  
  @Output() closeDialog = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data

  ) {}

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.message = this.data.message || this.message;
    this.dataRows = this.data.dataRows || this.dataRows;
    this.columns = this.data.columns || this.columns;
  // Don't use `||` here because it would treat `false` as "unset".
  this.showGrid = (this.data.showGrid !== undefined) ? this.data.showGrid : this.showGrid;
  }

  cancelConfirmation() {
    this.dialogRef.close();
  }
}
